export default __webpack_public_path__ + "static/media/GoogleLogo.3cec7ff9.svg";